export const enum MFAWidgetType {
  SETUP = "SETUP",
  SETTINGS = "SETTINGS",
  MISC = "MISC",
}
